import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Space,
  Card,
  Select,
  Row,
  Col,
  DatePicker,
  Button,
  Table,
  Tabs,
} from 'antd';
import { ImportOutlined } from '@ant-design/icons';
import { gql, useMutation, useLazyQuery } from '@apollo/client';
import moment from 'moment';

const { Option } = Select;
const { TabPane } = Tabs;

const FESummaryReport = ({ history, match }) => {
  const handleChange = () => {};

  const columns = [
    {
      title: 'AM CODE',
      dataIndex: 'am_emp_id',
      key: 'am_emp_id',
      serverKey: 'AM_EMP_ID',
      dataType: 'string',
      fixed: 'left',
    },
    {
      title: 'LOC',
      dataIndex: 'location',
      key: 'location',
      serverKey: 'LOC',
      dataType: 'string',
      fixed: 'left',
    },
    {
      title: 'EMP CODE',
      dataIndex: 'emp_id',
      key: 'emp_id',
      serverKey: 'EMP_ID',
      dataType: 'string',
      fixed: 'left',
    },
    {
      title: 'EMP NAME',
      dataIndex: 'name',
      key: 'name',
      serverKey: 'NAME',
      dataType: 'string',
      fixed: 'left',
      ellipsis: true,
    },
    {
      title: 'DESG',
      dataIndex: 'designation',
      key: 'designation',
      serverKey: 'DESG',
      dataType: 'string',
    },
    {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status',
      serverKey: 'STATUS',
      dataType: 'string',
    },
    {
      title: 'BASIC',
      dataIndex: 'basic',
      key: 'basic',
      dataType: 'string',
    },
    {
      title: 'CONVEYANCE',
      dataIndex: 'conveyance',
      key: 'conveyance',
      dataType: 'string',
    },
    {
      title: 'FE INCENTIVES',
      dataIndex: 'fe_incentives',
      key: 'fe_incentives',
      dataType: 'string',
      children: [
        {
          title: 'Al',
          dataIndex: 'fe_al',
          key: 'fe_al',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'PL/LAP',
          dataIndex: 'fe_pl_lap',
          key: 'fe_pl_lap',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'TW',
          dataIndex: 'fe_tw',
          key: 'fe_tw',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'CV',
          dataIndex: 'fe_cv',
          key: 'fe_cv',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'TRL',
          dataIndex: 'fe_trl',
          key: 'fe_trl',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'WOF',
          dataIndex: 'fe_wof',
          key: 'fe_wof',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'HDB',
          dataIndex: 'fe_hbd',
          key: 'fe_hbd',
          dataType: 'string',
          width: '75px',
        },
      ],
    },
    {
      title: 'TL INCENTIVES',
      dataIndex: 'tl_incentives',
      key: 'tl_incentives',
      dataType: 'string',
      children: [
        {
          title: 'Al',
          dataIndex: 'fe_al',
          key: 'fe_al',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'PL/LAP',
          dataIndex: 'fe_pl_lap',
          key: 'fe_pl_lap',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'TW',
          dataIndex: 'fe_tw',
          key: 'fe_tw',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'CV',
          dataIndex: 'fe_cv',
          key: 'fe_cv',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'TRL',
          dataIndex: 'fe_trl',
          key: 'fe_trl',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'WOF',
          dataIndex: 'fe_wof',
          key: 'fe_wof',
          dataType: 'string',
          width: '75px',
        },
        {
          title: 'HDB',
          dataIndex: 'fe_hbd',
          key: 'fe_hbd',
          dataType: 'string',
          width: '75px',
        },
      ],
    },
    {
      title: 'SPL PAY',
      dataIndex: 'spl_pay',
      key: 'spl_pay',
      dataType: 'string',
    },
    {
      title: 'GROSS PAY',
      dataIndex: 'gross_pay',
      key: 'gross_pay',
      dataType: 'string',
      fixed: 'right',
    },
  ];

  const getMockData = (count) => {
    const row = {
      am_emp_id: 'NGL0001',
      location: 'NGL',
      emp_id: 'NGL0023',
      name: 'Ramakrishnan N',
      designation: 'TL',
      status: 'WORKING',
      basic: '45000',
      conveyance: '10000',
      fe_al: '15,000',
      fe_pl_lap: '',
      fe_tw: '35',
      fe_cv: '',
      fe_trl: '',
      fe_wof: '45',
      fe_hbd: '',
      spl_pay: '5000',
      gross_pay: '60000',
    };

    const data = [];
    for (let i = 0; i < count; i++) {
      data.push(row);
    }
    return data;
  };

  // const data = [
  //   {
  //     am_emp_id: 'NGL0001',
  //     location: 'NGL',
  //     emp_id: 'NGL0023',
  //     name: 'Ramakrishnan N',
  //     designation: 'TL',
  //     status: 'WORKING',
  //     basic: '45000',
  //     conveyance: '10000',
  //     fe_al: '150',
  //     fe_pl_lap: '',
  //     fe_tw: '35',
  //     fe_cv: '',
  //     fe_trl: '',
  //     fe_wof: '45',
  //     fe_hbd: '',
  //     spl_pay: '5000',
  //     gross_pay: '60000',
  //   },
  //   {
  //     am_emp_id: 'NGL0001',
  //     location: 'NGL',
  //     emp_id: 'NGL0178',
  //     name: 'Suresh Kumar G',
  //     designation: 'FE',
  //     status: 'WORKING',
  //     basic: '15000',
  //     conveyance: '2500',
  //     fe_al: '0',
  //     fe_pl_lap: '250',
  //     fe_tw: '750',
  //     fe_cv: '',
  //     fe_trl: '85',
  //     fe_wof: '',
  //     fe_hbd: '',
  //     spl_pay: '1500',
  //     gross_pay: '20500',
  //   },
  // ];

  return (
    <Card className="expenseCard" style={{ minHeight: '200px' }}>
      <Row>
        <Col xs="12" md="2">
          <Space>
            <Select
              style={{ width: 150 }}
              onChange={handleChange}
              placeholder="Select Location"
            >
              <Option value="ngl">Nagercoil</Option>
              <Option value="mar">Marthandom</Option>
            </Select>

            <Select
              style={{ width: 150 }}
              onChange={handleChange}
              placeholder="Select AM"
            >
              <Option value="Ragupathy">Ragupathy</Option>
              <Option value="Ganehs">Ganesh</Option>
            </Select>

            <DatePicker
              defaultValue={moment('01/2019', 'MM/YYYY')}
              format={'MM/YYYY'}
              picker="month"
            />

            <Button type="primary" htmlType="submit">
              Apply Filter
            </Button>
          </Space>
        </Col>
      </Row>
      <Table
        size="small"
        bordered={true}
        columns={columns}
        dataSource={getMockData(20)}
        scroll={{ x: 2000, y: 500 }}
        pagination={false}
      />
    </Card>
  );
};

export default FESummaryReport;
